import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Snackbar,
  Alert,
  Grid,
  Paper,
  Box,
} from '@mui/material';
import { getObligacionNormativa } from '../../componentes/http/actions/ObligacionAction';

const DetalleObligaciones = () => {
  const { idNormativa } = useParams();
  const [obligaciones, setObligaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const fetchObligaciones = useCallback(() => {
    setIsLoading(true);
    
    // El token puede ser null para acceso público
    const token = localStorage.getItem("token");
    
    getObligacionNormativa(token, idNormativa)
      .then((response) => {
        setObligaciones(response);
      })
      .catch((error) => {
        console.error("Error fetching obligaciones:", error);
        setSnackbar({
          open: true,
          message: "Error al cargar las obligaciones",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  }, [idNormativa]);

  useEffect(() => {
    if (idNormativa) {
      fetchObligaciones();
    }
  }, [fetchObligaciones, idNormativa]);

  // Obtener el nombre de la normativa de la primera obligación
  const nombreNormativa = obligaciones.length > 0 ? obligaciones[0].nombreNormativa : null;

  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid item>
          <Typography variant="h4">
            Obligaciones
          </Typography>
          {nombreNormativa && (
            <Typography variant="h6" sx={{ mt: 1 }}>
              Normativa: {nombreNormativa}
            </Typography>
          )}
        </Grid>

        {isLoading && !initialDataLoaded ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : obligaciones.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Descripción</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {obligaciones.map((obligacion) => (
                <TableRow key={obligacion.id}>
                  <TableCell>{obligacion.descripcion}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography>No hay obligaciones para esta normativa.</Typography>
        )}

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Paper>
    </Grid>
  );
};

export default DetalleObligaciones;